import styled from 'styled-components';
import PropTypes from 'prop-types';
// TODO: Implement once UX delivers the DDS
export const LayerPropTypes = {
    background: PropTypes.string,
    borderSize: PropTypes.number,
    borderColor: PropTypes.string,
    borderRadius: PropTypes.number,
    padding: PropTypes.number,
    mode: PropTypes.oneOf(['primary', 'secondary'])
};
export const Layer = styled.div `
    display: inline-block;
    background-color: ${(props) => props.background || 'transparent'};
    border-radius: ${(props) => props.borderRadius || 'none'};
    padding: ${(props) => props.padding || '5px'};
    border-color: ${(props) => props.borderColor || 'transparent'};
    border-width: ${(props) => props.borderColor || '0'};
    border-style: ${(props) => props.borderColor || 'solid'};
    ${props => props.mode === 'primary' ? `
    
    ` : ``}
`;
//# sourceMappingURL=Layer.styled.js.map